export default {
  date:'YYYY年MM月',
}
